import {Validator} from '@/type/validation/result';
import {半角カナ禁止, 必須入力, 日付書式} from '@/type/validation/validator';

function 三文字以上の入力が必要(value: string) {
    if (!value) {
        return false;
    }
    return (value.length >= 3);
}

function 数値が1以上の整数(value: number) {
    return Number.isInteger(value) && value > 0;
}

export const 発注未確定絞込条件バリデータ一覧: Validator[] = [
  {
    name: '商品名カナ検索文字列',
    constraints: [
      {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
    ],
  },
  {
    name: '発注日開始日付',
    constraints: [
      {method: 日付書式, message: '発注日(開始日付)の書式が不正です'},
    ],
  },
  {
    name: '発注日終了日付',
    constraints: [
      {method: 日付書式, message: '発注日(終了日付)の書式が不正です'},
    ],
  },
  {
    name: '納品予定日開始日付',
    constraints: [
        {method: 日付書式, message: '納品予定日(開始日付)の書式が不正です'},
    ],
  },
  {
    name: '納品予定日終了日付',
    constraints: [
      {method: 日付書式, message: '納品予定日(終了日付)の書式が不正です'},
    ],
  },
];

export const 商品追加検索条件バリデータ一覧: Validator[] = [
  {
    name: '商品名カナ',
    constraints: [
      {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
      {method: 三文字以上の入力が必要, message: '商品名カナは３文字以上の入力が必要です'},
    ],
  },
];

export const 定点発注追加検索条件バリデータ一覧: Validator[] = [
  {
    name: '商品名カナ',
    constraints: [
      {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
    ],
  },
];

export const 定点発注追加情報バリデータ一覧: Validator[] = [
  {
    name: '発注数',
    constraints: [
      {method: 数値が1以上の整数, message: '発注数は1以上の整数で入力してください'},
    ],
  },
];

export const 履歴追加検索条件バリデータ一覧: Validator[] = [
  {
    name: '商品名カナ',
    constraints: [
      {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
    ],
  },
  {
    name: '発注日開始日付',
    constraints: [
      {method: 必須入力, message: '発注日(開始日付)は入力が必要です'},
      {method: 日付書式, message: '発注日(開始日付)の書式が不正です'},
    ],
  },
  {
    name: '発注日終了日付',
    constraints: [
      {method: 日付書式, message: '発注日(終了日付)の書式が不正です'},
    ],
  },
];

export const 発注情報バリデータ一覧: Validator[] = [
    {
      name: '発注数',
      constraints: [
        {method: 数値が1以上の整数, message: '発注数は1以上の整数で入力してください'},
      ],
    },
    {
      name: '発注日',
      constraints: [
        {method: 日付書式, message: '発注日の書式が不正です'},
      ],
    },
    {
      name: '納品指定日',
      constraints: [
        {method: 日付書式, message: '納品指定日の書式が不正です'},
      ],
    },
    {
      name: '卸コード',
      constraints: [
        {method: 必須入力, message: '卸が指定されていません'},
      ],
    },
  ];

export const コード入力検索条件バリデータ一覧: Validator[] = [
    {
      name: 'JANコードまたは販売GTINコード',
      constraints: [
        {method: 必須入力, message: 'JAN/GTINコードは入力が必須です'},
      ],
    },
  ];
